import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustryMobilityPayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
